import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Check if we're already waiting for AI completion
    const params = new URLSearchParams(window.location.search)
    if (params.get('ai_generating') === 'true') {
      this.startPolling()
    }
  }

  startPolling(event) {
    if (event) {
      event.preventDefault()
    }

    // Add query param to indicate we're generating
    const url = new URL(window.location)
    url.searchParams.set('ai_generating', 'true')
    window.history.pushState({}, '', url)

    // Start polling
    this.pollInterval = setInterval(() => {
      this.checkStatus()
    }, 3000) // Poll every 3 seconds
  }

  async checkStatus() {
    const campaignId = window.location.pathname.split('/').pop()
    const response = await fetch(`/sp/campaigns/${campaignId}/check_plan_status`)
    const data = await response.json()

    if (data.status === 'complete') {
      clearInterval(this.pollInterval)
      // Remove query param and reload
      const url = new URL(window.location)
      url.searchParams.delete('ai_generating')
      window.location.href = url.toString()
    } else if (data.status === 'failed') {
      clearInterval(this.pollInterval)
      alert(`AI generation failed: ${data.error}`)
      // Reload to show error
      const url = new URL(window.location)
      url.searchParams.delete('ai_generating')
      window.location.href = url.toString()
    }
    // Otherwise keep polling (status === 'pending')
  }

  disconnect() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
    }
  }
}
